//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveExtensionBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AnchorPoint",1,"Point",0],[0,"AssociativeToggle",1,0],[0,"CoefficientCSYS",1,"CoordinateSystem",0],[0,"ConstrainedPlaneCSYS",1,"CoordinateSystem",0],[0,"DrawingPlaneOption",1,0],[0,"EndPoint",1,"Point",0],[1,"Extender",0,"GeometricUtilities.CurveExtensionBuilder",0],[0,"GeneralDrawingPlane",1,"Plane",0],[0,"InteriorPoint1",1,"Point",0],[0,"InteriorPoint2",1,"Point",0],[0,"InteriorPoint3",1,"Point",0],[0,"PlaneConstrainedToggle",1,0],[1,"Rho",0,"Expression",0],[0,"RhoValue",1,1],[0,"SlopeAtEndPoint",1,"Direction",0],[0,"SlopeAtStartPoint",1,"Direction",0],[0,"StartPoint",1,"Point",0],[0,"Type",1,0],[0,"ValueA",1,0],[0,"ValueB",1,0],[0,"ValueC",1,0],[0,"ValueD",1,0],[0,"ValueE",1,0],[0,"ValueF",1,0]],[[[],"Evaluate",{},0,0]],[]];
SPLM.Features.GeneralConicBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.GeneralConicBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.GeneralConicBuilder.Types = Object.freeze({
    "FivePoints" : "FivePoints", "FourPointsOneSlope" : "FourPointsOneSlope", "ThreePointsTwoSlopes" : "ThreePointsTwoSlopes", "ThreePointsAnchor" : "ThreePointsAnchor", "TwoPointsAnchorRho" : "TwoPointsAnchorRho", "TwoPointsTwoSlopesRho" : "TwoPointsTwoSlopesRho", "Coefficients" : "Coefficients"});

SPLM.Features.GeneralConicBuilder.DrawingPlaneOptions = Object.freeze({
    "View" : "View", "XcYc" : "XcYc", "YcZc" : "YcZc", "ZcXc" : "ZcXc", "General" : "General"});

export default SPLM;